import React, { useState, useRef, useEffect } from 'react';
import { Link, useParams } from "react-router-dom";
import Select, { components } from "react-select";
import { Badge } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import DatePicker from 'react-multi-date-picker';   
import dayjs from 'dayjs';
import axios from 'axios';
import moment from "moment";
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const VendorPayment = () => {  
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const sno = queryParams.get('data');
    const baseURL = process.env.REACT_APP_API_BASE_URL; 
    // const { sno } = useParams();
    const navigate = useNavigate();
    const tableRef = useRef(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [purchase, setPurchase] = useState([]);
    const [vendorName, setVendorName] = useState("");
    
    // Payment modes fetched from API
    const [paymentmode, setPaymode] = useState([]);
    const [selectedPayment, setSelectedPayment] = useState(null);
    const [transactionId, setTransactionId] = useState('');
    const [isVisible, setIsVisible] = useState(false);
    const [paymentAmount, setPaymentAmount] = useState("");

    const Group = (props) => (
        <div style={customStyles}>
            <components.Group {...props} />
        </div>
    );

    const customStyles = {
        groupHeading: (provided) => ({
            ...provided,
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#333',
        }),
    };

    // Fetch vendor payments
    useEffect(() => {
        if (!sno) return;

        axios.get(`${baseURL}/vendor-payments/${sno}`)
            .then((res) => {
                if (res.data && res.data.data) {
                    setPurchase(res.data.data);
                    if (res.data.data.length > 0) {
                        setVendorName(res.data.data[0].vendor_name);
                    }
                }
            })
            .catch((err) => console.error(err));
    }, [sno, baseURL]);

    // Fetch active payment modes
    useEffect(() => {
        const fetchpaymode = async () => {
            try {
                const response = await axios.get(`${baseURL}/paymentmode/getactive`);
                const formatted = response.data.map(item => ({
                    value: item.sno,
                    label: item.paymentmode_name,
                    transaction_id: item.transaction_id,
                }));
                setPaymode(formatted);
            } catch (error) {
                console.log('Error fetching payment modes:', error);
            }
        };
        fetchpaymode();
    }, [baseURL]);

    // Initialize DataTable
    useEffect(() => {
        if (tableRef.current && !$.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable({
                responsive: true,
                pageLength: 25,
                ordering: false,
                language: { lengthMenu: "Show&nbsp;&nbsp; _MENU_" },
                dom: "<'row'<'col-sm-12 d-flex align-items-center justify-content-end mb-2'f>>" +
                     "<'table-responsive'tr>" +
                     "<'row'>"
            });
        }
    }, []);

    const handleDateChange = (index, date) => {
        const newData = [...purchase];
        newData[index].paid_date = date;
        setPurchase(newData);
    };

    const totalAmount = purchase.reduce((sum, item) => sum + parseFloat(item.purchase_amount), 0);

    const handlePayClick = (index) => {
        const item = purchase[index];
        setSelectedRow({
            ...item,
            payDate: item.paid_date 
                ? dayjs(item.paid_date).format("DD-MMM-YYYY") 
                : dayjs().format("DD-MMM-YYYY")  // default to today if no date
        });
        setPaymentAmount(item.purchase_amount);
        setSelectedPayment(null);
        setTransactionId('');
        setIsVisible(false);
    };

    const handlePaymentModeChange = (option) => {
        setSelectedPayment(option.value);
        setIsVisible(option.transaction_id === 0); // Show transaction input if transaction_id === 0
    };

    const handlePayNow = async () => {
        if (!selectedPayment) {
            alert("Please select a payment mode.");
            return;
        }

        if (isVisible && transactionId.trim() === '') {
            alert("Please enter a transaction ID.");
            return;
        }

        if (!paymentAmount || parseFloat(paymentAmount) <= 0) {
            alert("Please enter a valid payment amount.");
            return;
        }

        if (parseFloat(paymentAmount) > parseFloat(selectedRow.purchase_amount)) {
            alert("Payment amount cannot be more than total amount.");
            return;
        }

        try {
            // Prepare payload with all required fields
            const payload = {
                purchase_id: selectedRow.purchase_id,
                purchase_date: dayjs(selectedRow.purchase_date).format("YYYY-MM-DD"),
                paid_amount: parseFloat(paymentAmount),
                paid_date: dayjs(selectedRow.payDate, "DD-MMM-YYYY").format("YYYY-MM-DD"),
                purchase_amount: parseFloat(selectedRow.purchase_amount),
                vendorpayment_id: selectedRow.vendorpayment_id, // if required by backend
                payment_mode: selectedPayment,
                transaction_id: transactionId,
            };

            // Get vendor_id from the purchase data
            const vendorId = purchase.length > 0 ? purchase[0].vendor_id : null;

            if (!vendorId) {
                alert("Vendor ID not found.");
                return;
            }

            // Correctly include vendor_id in the URL
            const res = await axios.post(`${baseURL}/vendor-payments/${vendorId}`, payload);

            if (res.data.status) {
                setSelectedRow(null);
                const updated = await axios.get(`${baseURL}/vendor-payments/${sno}`);
                if (updated.data && updated.data.data) {
                    setPurchase(updated.data.data);
                }
                navigate('/manage-vendors', {
                    state: { toastMessage: 'Vendor Payment Successfull!', toastType: 'success' }
                });
            } else {
                navigate('/manage-vendors', {
                    state: { toastMessage: 'Vendor Payment Failed!', toastType: 'error' }
                });
            }
        } catch (error) {
            console.error(error);
            navigate('/manage-vendors', {
                state: { toastMessage: 'Vendor Payment Failed!', toastType: 'error' }
            });
        }
    };

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 flex-wrap">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Vendor Payment - {vendorName}</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item">Purchase Management</li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active"><Link to='/manage-items'>Manage Vendors</Link></li>
                    </ol>
                </div>
            </div>

            <div className='row mb-4'>
                <div className="table-container">
                    <table  className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                        <thead>
                            <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                {/* <th className='min-w-100px'>Pay Date</th> */}
                                <th className='min-w-100px'>Purchase Id</th>
                                <th className='min-w-50px'>Purchase Date</th>
                                <th className='min-w-50px'>Purchase /Paid Amount</th> 
                                <th className='min-w-100px'>Pay Date</th>
                                <th className='min-w-50px'>Staff / Raw Material</th>
                                <th className='min-w-80px'>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {purchase.map((item, index) => (
                                <tr key={index}>
                                    {/* <td>
                                        <DatePicker
                                            value={item.paid_date ? moment(item.paid_date, "YYYY-MM-DD") : null}
                                            format="DD-MM-YYYY"
                                            onChange={(date) => handleDateChange(index, date)}
                                            placeholder="Select date"
                                        />
                                    </td> */}
                                    <td>
                                        <label className='font-w600 fs-7 text-black'>
                                            {`managepurchase_${String(item.purchase_id).padStart(4, '0')}`}
                                        </label>
                                    </td>
                                    <td>
                                        <label className='font-w600 fs-7 text-primary border rounded border-primary py-1 px-2'>
                                            {dayjs(item.purchase_date).format("DD-MMM-YYYY")}
                                        </label>
                                    </td>
                                    <td align='right'>
                                        <span className='badge border border-danger text-danger fs-7'>
                                            ₹ {parseFloat(item.purchase_amount).toLocaleString()}
                                        </span> / 
                                        <span className='badge border border-success text-success fs-7'>
                                            ₹ {parseFloat(item.paid_amount).toLocaleString()}
                                        </span>
                                    </td>
                                    <td>
                                        <label className='font-w600 fs-7 text-primary border rounded border-primary py-1 px-2'>
                                            {dayjs(item.paid_date).format("DD-MMM-YYYY")}
                                        </label>
                                    </td>
                                    <td>
                                        <div className='d-flex flex-row gap-2 align-items-center'>
                                            <label className='font-w600 fs-7 text-black'><strong>{item.staff_name}</strong></label>
                                            <Badge bg="warning" className='text-white fs-7 py-0 px-1 rounded'>{item.raw_material_count}</Badge>
                                        </div>
                                    </td>
                                    <td>
                                        {item.payment_status === 1 ? (
                                            <label className='bg-success text-white py-1 px-2 rounded font-w600'>Paid</label>
                                        ) : (
                                            <Link className="btn btn-sm btn-primary" onClick={() => handlePayClick(index)}>Pay</Link>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colSpan={3} align='right'>
                                    <label className='font-w500 fs-5 text-danger'>Total Outstanding Amount</label>
                                </th>
                                <th className='text-end'>
                                    <label className="font-w600 fs-5 text-danger">₹ {totalAmount.toLocaleString()}</label>
                                </th>
                                <th colSpan={2}></th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>

            {selectedRow && (
                <div className='card shadow-sm border border-primary-subtle' style={{ backgroundColor: '#f9f0ff' }}>
                    <div className="card-header bg-primary text-white py-2 px-3 d-flex justify-content-between align-items-center">
                        <h6 className="mb-0 text-white">Confirm Payment</h6>
                        <button onClick={() => setSelectedRow(null)} className="btn btn-sm btn-light text-danger">Cancel</button>
                    </div>
                    <div className='row py-4 px-3'>
                        <div className="col-md-3 mb-3">
                            <label className="form-label fw-semibold text-black">Pay Date</label>
                            <div className="form-control bg-light">{selectedRow.payDate}</div>
                        </div>
                        <div className="col-md-3 mb-3">
                            <label className="form-label fw-semibold text-black">Purchase ID</label>
                            <div className="form-control bg-light">{selectedRow.vendorpayment_id || selectedRow.purchase_id}</div>
                        </div>
                        <div className="col-md-3 mb-3">
                            <label className="form-label fw-semibold text-black">Payment Mode</label>
                            <Select
                                placeholder="Select Payment Mode"
                                value={paymentmode.find(pm => pm.value === selectedPayment) || null}
                                options={paymentmode}
                                onChange={handlePaymentModeChange}
                                components={{ Group }}
                                styles={customStyles}
                            />
                        </div>
                        {isVisible && (
                            <div className="col-md-3 mb-3">
                                <label className="form-label fw-semibold text-black">Transaction ID</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={transactionId}
                                    onChange={(e) => setTransactionId(e.target.value)}
                                    placeholder="Enter Transaction ID"
                                />
                            </div>
                        )}
                        <div className="col-md-3 mb-3">
                            <label className="form-label fw-semibold text-black">Total Amount</label>
                            <input
                                type="text"
                                className="form-control bg-light"
                                value={selectedRow.purchase_amount}
                                readOnly
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label className="form-label fw-semibold text-black">Payment Amount</label>
                            <input
                                type="number"
                                className="form-control"
                                value={paymentAmount}
                                onChange={(e) => setPaymentAmount(e.target.value)}
                                min="0"
                                max={selectedRow.purchase_amount}
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label className="form-label fw-semibold text-black">Balance Amount</label>
                            <input
                                type="text"
                                className="form-control bg-light"
                                value={`₹ ${((selectedRow.purchase_amount || 0) - (parseFloat(paymentAmount) || 0)).toLocaleString()}`}
                                readOnly
                            />
                        </div>
                        <div className="col-12 d-flex justify-content-end mt-3">
                            <button onClick={handlePayNow} className="btn btn-sm btn-primary">Pay Now</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default VendorPayment;
